import PropTypes from "prop-types";
import React from "react";
import useDocumentStatuses from "~/hooks/documents/useDocumentStatuses";
import Select from "./SelectWrapper/Select";

const DocumentStatusSelect = ({
  id = "document_status",
  value,
  onChange,
  placeholder = "Select Status",
  isClearable = true,
  isSearchable = false,
  ...restProps
}) => {
  const { options, loading } = useDocumentStatuses();

  return (
    <Select
      validateValue
      id={id}
      name="status"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      isClearable={isClearable}
      isSearchable={isSearchable}
      isLoading={loading}
      options={options}
      {...restProps}
    />
  );
};

DocumentStatusSelect.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
};

export default DocumentStatusSelect;
